import React from "react";
import './newsletterForm.scss';
import {POST_XHTTP} from "../../../services/xhttps";
import {useFormik} from "formik";
import * as Yup from "yup";
import {InputType} from "../../../types/UITypes";
import Input from "../../../components/ui/form/Input";
import {useTranslation} from "gatsby-plugin-react-i18next";
import SvgChevron from "../../../components/ui/icons/SvgChevron";

const NewsletterForm = () => {
    const {t} = useTranslation('common');

    const handleSubmit = ({email}: {email: string}) => {
        POST_XHTTP('users/newsletter', { email })
            .then(() => {
                // TODO
                alert(`Ton inscription a bien été prise en compte !`);
            })
            // TODO
            .catch(() => alert('Oops, quelque chose s\'est mal passé...'));
    };

    const formik = useFormik({
        initialValues: {
            email: '',
        },
        validationSchema: Yup.object({
            email: Yup.string().email('Adresse email non valide').required('Requis'),
        }),
        onSubmit: values => handleSubmit(values),
    });

    return (
        <>
            <form
                className='newsletterForm'
                onSubmit={formik.handleSubmit}
            >
                <Input
                    value={formik.values.email}
                    placeholder={t('newsletter.emailPlaceholder')}
                    type={InputType.Text}
                    onChange={formik.handleChange}
                    name='email'
                    id='contactEmail'
                    errors={formik.errors.email}
                    touched={formik.touched.email}
                />
                <button
                    type='submit'
                    role='button'
                    className='inputSendButton'
                    title="S'inscrire"
                >
                    <SvgChevron direction='right' color='#FFF' />
                </button>
            </form>
            {
                (formik.touched.email && formik.errors.email)
                    ? (<p><span className='errorText'>{formik.errors.email}</span></p>)
                    : null
            }
        </>

    );
};

export default NewsletterForm;